import { clientApp } from './index';

export const getFields = (type: string) => clientApp.get(`/ui/bitrix/${type}/fields`);
